import { OnboardingResumePage } from "@/interface/pages/onboarding/onb-resume";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/users/onboarding/resume")(
  {
    component: RouteComponent,
  }
);

function RouteComponent() {
  return <OnboardingResumePage />;
}
